/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:08:33
 * @Description: 维保计划路由
 */
const gzwxRoutes = {
  path: 'gzwx',
  name: 'gzwx',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'wbrw',
      name: 'wbrwList',
      component: () => import(/* webpackChunkName: "wbrwList" */'@/features/xfwbgl/gzwx/wbrw.vue'),
      meta: {
        navtabTitle: '维保任务',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'gzwx/:xmId',
      name: 'gzwxView',
      component: () => import(/* webpackChunkName: "gzwxView" */'@/features/xfwbgl/gzwx/gzwx.vue'),
      meta: {
        navtabTitle: '故障维修台账',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default gzwxRoutes;
